import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./outline/forecast-downgrade.svg";
var ForecastDowngradeOutline_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  ForecastDowngradeOutline_default as default
};
